import { useEffect } from "react"
import { X } from "lucide-react"

export const Drawer = ({ open, title, onClose, footer, wide = false, children }) => {
  useEffect(() => {
    if (!open) return undefined
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.()
    }
    window.addEventListener("keydown", onKey)
    return () => window.removeEventListener("keydown", onKey)
  }, [open, onClose])

  if (!open) return null

  return (
    <div className="ds-drawer-root">
      <div className="ds-drawer-backdrop" onClick={onClose} aria-hidden />
      <aside
        className={`ds-drawer-panel${wide ? " ds-drawer-panel--wide" : ""}`}
        role="dialog"
        aria-modal="true"
        aria-label={typeof title === "string" ? title : "Details"}
      >
        <div className="ds-drawer-head">
          <div style={{ minWidth: 0 }}>{typeof title === "string" ? <h2 className="pc-h1" style={{ fontSize: 18 }}>{title}</h2> : title}</div>
          <button type="button" className="pc-btn pc-btn--ghost pc-btn--sm" onClick={onClose} aria-label="Close">
            <X size={16} aria-hidden />
          </button>
        </div>
        <div className="ds-drawer-body">{children}</div>
        {footer && (
          <div style={{ padding: "12px 18px", borderTop: "1px solid var(--border)", position: "sticky", bottom: 0, background: "var(--bg-surface)" }}>
            {footer}
          </div>
        )}
      </aside>
    </div>
  )
}

export default Drawer
